export default __webpack_public_path__ + "static/media/robot.40424237.png";